import { Teacher, Subject, Room, Student } from './classes.js';
export default {
    year(thing, y) {
        if (!thing.getYearLevel)
            return false;
        return thing.getYearLevel() == y;
    },
    house(thing, h) {
        if (!h)
            return false;
        var houses = ['BH', 'KM', 'CN', 'MS'];
        var house = houses.find(h_ => h_[0] == h[0].toUpperCase());
        return thing.getHouse && thing.getHouse() == house;
    },
    teacher(thing) {
        return thing instanceof Teacher;
    },
    student(thing) {
        return thing instanceof Student;
    },
    room(thing) {
        return thing instanceof Room;
    },
    male(thing) {
        if (!thing)
            return false;
        return thing.StudentGender == 'M';
    },
    female(thing) {
        if (!thing)
            return false;
        return thing.StudentGender == 'F';
    },
    type(thing, t) {
        if (t == 'student')
            return thing instanceof Student;
        if (t == 'teacher')
            return thing instanceof Teacher;
        if (t == 'room')
            return thing instanceof Room;
        if (t == 'subject')
            return thing instanceof Subject;
        console.warn('Cannot filter type:', t);
        return true;
    }
};
